// extracted by mini-css-extract-plugin
var _1 = "arSH0";
export { _1 as "base" }
